<template>
  <div class="mobile-industry">
    <!-- 行业分类 -->
    <div class="category-list">
      <div
        v-for="(item, index) in categories"
        :key="index"
        class="category-item"
        :class="{ active: currentCategory === item.id }"
        @click="handleCategoryChange(item.id)"
      >
        {{ item.title }}
      </div>
    </div>

    <!-- 解决方案列表 -->
    <div class="solution-list">
      <div
        v-for="(item, index) in solutionList"
        :key="index"
        class="solution-item"
        @click="goToDetail(item)"
      >
        <div class="solution-image"  v-if="!selectedSolution">
          <img :src="item.image" :alt="item.title">
          <div class="solution-image-info">
            <div class="solution-title">{{ item.title }}</div>
            <p class="solution-body">
              <span class="solution-desc" v-html="$formatContent(item.content, 29)"></span>
              <span class="show-more" @click="goToDetail(item)">查看更多</span>
            </p>
          </div>
        </div>
        <div class="solution-info" v-else>
          <el-button type="text" icon="el-icon-arrow-left" @click="backToList" style="margin-bottom: 16px;">返回</el-button>
          <div class="title">{{ item.title }}</div>
          <div class="desc" v-html="item.content"></div>
        </div>
      </div>
    </div>

    <!-- 加载更多 -->
    <div class="load-more" v-if="hasMore" @click="loadMore">
      <span v-if="!loading">加载更多</span>
      <span v-else>加载中...</span>
    </div>
  </div>
</template>

<script>
import { articleList, articleClass } from '@/api/index'
export default {
  name: 'MobileIndustry',
  data() {
    return {
      categories: [],
      currentCategory: null,
      solutionList: [],
      page: 1,
      pageSize: 10,
      hasMore: true,
      loading: false,
      selectedSolution: null
    }
  },
  created() {
    this.getCategories()
  },
  methods: {
    getCategories() {
      articleClass({classify_id: 3}).then(res => {
        if (res.data) {
          this.categories = res.data.rows
          if (this.categories.length > 0) {
            this.currentCategory = this.categories[0].id
            this.getSolutions(this.currentCategory)
          }
        }
      })
    },
    getSolutions(id) {
      this.loading = true
      articleList({
        classify_id: id
      }).then(res => {
        this.loading = false
        if (res.data.rows) {
          this.solutionList = res.data.rows.filter(item => item.status !== 0)
        } else {
          this.solutionList = []
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleCategoryChange(categoryId) {
      this.currentCategory = categoryId
      this.solutionList = []
      this.getSolutions(this.currentCategory)
    },
    loadMore() {
      if (this.loading) return
      this.page++
      this.getSolutions()
    },
    goToDetail(item) {
      this.selectedSolution = item
    },
    backToList() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-industry {
  padding: 15px;
}

.category-list {
  display: flex;
  overflow-x: auto;
  margin-bottom: 15px;
  padding-bottom: 10px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  .category-item {
    flex-shrink: 0;
    padding: 8px 15px;
    margin-right: 10px;
    background: #f5f5f5;
    border-radius: 20px;
    font-size: 14px;
    color: #666;
    white-space: nowrap;

    &.active {
      background: #2c9dcf;
      color: #fff;
    }
  }
}

.solution-list {
  .solution-item {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 15px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);

    .solution-image {
      width: 100%;
      height: 140px;
      overflow: hidden;
      display: flex;
      justify-content: flex-start;

      img {
        width: 120px;
        height: 100%;
        object-fit: cover;
        padding-right: 10px;
      }
      .solution-title {
        font-weight: 500;
      }
      .solution-desc {
        font-size: 13px;
        color: #777;
        line-height: 1.4;
        margin-top: 4px;
      }
      .show-more {
        font-size: 12px;
        color: #2c9dcf;
        margin-top: 4px;
        cursor: pointer;
      }
    }

    .solution-info {
      padding: 15px;

      .title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin-bottom: 10px;
      }

      .desc {
        font-size: 14px;
        color: #666;
        line-height: 1.6;
        margin-bottom: 15px;
      }
    }
  }
}

.load-more {
  text-align: center;
  padding: 15px 0;
  color: #666;
  font-size: 14px;
}
</style>
